// Path: sec-parser/client/src/store/index.js
import { configureStore, createSlice } from "@reduxjs/toolkit";

// ── Auth Slice ────────────────────────────────────────────────────────────
const authSlice = createSlice({
  name: "auth",
  initialState: {
    user:        null,
    token:       localStorage.getItem("accessToken") || null,
    isLoggedIn:  !!localStorage.getItem("accessToken"),
    loading:     false,
  },
  reducers: {
    setCredentials: (state, { payload }) => {
      state.user      = payload.user;
      state.token     = payload.accessToken;
      state.isLoggedIn= true;
      localStorage.setItem("accessToken", payload.accessToken);
    },
    setUser: (state, { payload }) => {
      state.user = payload;
    },
    clearAuth: (state) => {
      state.user      = null;
      state.token     = null;
      state.isLoggedIn= false;
      localStorage.removeItem("accessToken");
    },
    setAuthLoading: (state, { payload }) => { state.loading = payload; },
  },
});

// ── Filings Slice ─────────────────────────────────────────────────────────
const filingsSlice = createSlice({
  name: "filings",
  initialState: { list: [], current: null, loading: false, error: null },
  reducers: {
    setFilings:  (state, { payload }) => { state.list    = payload; },
    setCurrent:  (state, { payload }) => { state.current = payload; },
    setLoading:  (state, { payload }) => { state.loading = payload; },
    setError:    (state, { payload }) => { state.error   = payload; },
    addFiling:   (state, { payload }) => { state.list.unshift(payload); },
  },
});

// ── Benchmark Slice ───────────────────────────────────────────────────────
const benchmarkSlice = createSlice({
  name: "benchmark",
  initialState: { currentRun: null, results: [], loading: false },
  reducers: {
    setCurrentRun:       (state, { payload }) => { state.currentRun = payload; },
    setResults:          (state, { payload }) => { state.results    = payload; },
    setBenchmarkLoading: (state, { payload }) => { state.loading    = payload; },
  },
});

// ── Store ─────────────────────────────────────────────────────────────────
export const store = configureStore({
  reducer: {
    auth:      authSlice.reducer,
    filings:   filingsSlice.reducer,
    benchmark: benchmarkSlice.reducer,
  },
});

export const { setCredentials, setUser, clearAuth, setAuthLoading } = authSlice.actions;
export const { setFilings, setCurrent, setLoading, setError, addFiling } = filingsSlice.actions;
export const { setCurrentRun, setResults, setBenchmarkLoading } = benchmarkSlice.actions;